<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type {
  PopoverContentEmits,
  PopoverContentProps,
} from 'reka-ui'

import { cn } from 'cn'
import {
  injectPopoverRootContext,
  PopoverContent,
  PopoverPortal,
  useForwardPropsEmits,
} from 'reka-ui'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<PopoverContentProps & { class?: HTMLAttributes['class'] }>(),
  {
    align: 'center',
    sideOffset: 4,
  },
)
const emits = defineEmits<PopoverContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

const rootContext = injectPopoverRootContext()

const close = () => rootContext.onOpenChange(false)
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'relative z-50 rounded-md ring-1 ring-neutral-200 bg-white p-4 text-neutral-950 shadow-md outline-none '
            + 'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 '
            + 'data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 '
            + 'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 '
            + 'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:ring-neutral-800 '
            + 'dark:bg-neutral-950 dark:text-neutral-50',
          props.class,
        )
      "
    >
      <slot :close />
    </PopoverContent>
  </PopoverPortal>
</template>
